import { combineReducers } from 'redux';
import advertForm from 'shared/reducers/advertForm';
import partsForm from 'shared/reducers/partsForm';
import searchForm from 'shared/reducers/searchForm';
import user from 'shared/reducers/user';
import history from 'shared/reducers/history';
import homeSpecialCars from 'shared/reducers/homeSpecialCars';
import homeNews from 'shared/reducers/homeNews';
import homeCounters from 'shared/reducers/homeCounters';
import advertTopCars from 'shared/reducers/advertTopCars';
import motoAdverts from 'shared/reducers/motoAdverts';
import globals from 'shared/reducers/globals';
import favorites from 'shared/reducers/favorites';
import notifications from 'shared/reducers/notifications';
import loading from 'shared/reducers/loading';

export default combineReducers({
  advertForm,
  partsForm,
  searchForm,
  user,
  history,
  homeSpecialCars,
  homeNews,
  homeCounters,
  advertTopCars,
  motoAdverts,
  globals,
  notifications,
  favorites,
  loading,
});



// WEBPACK FOOTER //
// ./src/desktop/reducers/index.js